export enum ESpeedMeasurementUnit {
	MILES_PER_HOUR = "mph",
	KNOTS = "knots",
	KILOMETERS_PER_HOUR = "km/h",
	METERS_PER_SECOND = "m/s",
}
